/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx, cssMap } from '@compiled/react';

import { RovoHexIcon } from '@atlaskit/logo/rovo-hex/icon';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { token } from '@atlaskit/tokens';

import type { SuggestionProfile } from '../../../aiSuggestionsPluginType';

const styles = cssMap({
	row: {
		display: 'inline-flex',
		alignItems: 'center',
		height: token('space.250'),
	},
});

/** Renders the compact Rovo identity used when no agent avatar is available. */
function RovoIdentity(): React.JSX.Element {
	return (
		<div css={styles.row}>
			<RovoHexIcon label="" size="xxsmall" />
		</div>
	);
}

export function SuggestionAgentIdentity({
	agent,
}: {
	agent?: SuggestionProfile | null;
}): React.JSX.Element {
	const name = agent?.name?.trim();

	if (!agent?.accountId || !name) {
		return <RovoIdentity />;
	}

	return (
		<div css={styles.row}>
			<AgentAvatar
				imageUrl={agent?.picture?.trim() || undefined}
				agentIdentityAccountId={agent.accountId}
				size="xsmall"
				label={name}
				showBorder={false}
			/>
		</div>
	);
}
